import React, { useEffect, useState } from "react";
import {
  AppBar,
  Avatar,
  Box,
  FormControl,
  ListItem,
  ListItemIcon,
  Toolbar,
  Typography,
} from "@mui/material";
import { Link, useHistory } from "react-router-dom";

import logo from "../../images/logo.png";
import Nameplate from "../Nameplate/Nameplate";
import Select from "../Select/Select";

import { ROUTES } from "../../routes";
import useClient from "../../hooks/useClient";
import useQueryParams, {
  COUNTRY_PARAM,
  ACCOUNT_PARAM,
} from "../../hooks/useQueryParams";
import { getSetValues } from "../LeftNav/LeftNavFilters";
import { COUNTRIES } from "../LeftNav/config/Filters";
import HomeIcon from "@mui/icons-material/Home";

type NavBarProps = {
  drawerWidth: number;
};
const DEFAULT_TAB = "fw";
const NavBar = ({ drawerWidth }: NavBarProps) => {
  let history = useHistory();
  const current = history.location.pathname.split("/")[1];
  const { search, queryParams: qp } = useQueryParams();
  const country = qp.get(COUNTRY_PARAM)?.toUpperCase();
  const { name, role } = useClient();
  const [loadValue, setLoadValue] = useState<string>("");

  // TODO: refactor the menu names into consts once unit tests are in place
  //  Currently, CH/BM should match the strings in COUNTRIES arr in Filter.ts with " - " as separator
  const navBarMenuItemsList: {name: string, value: string, disabled?: boolean}[] = [
    { value: ROUTES.NMP, name: "3PW - Nike Marketplace Partners - Units" },
    { value: ROUTES.NMP_WHOLESALE, name: "3PW - Nike Marketplace Partners - Whlse Amt" },
    { value: ROUTES.NSP, name: "3PW - Nike Store Partners - Units" },
    { value: ROUTES.NSP_WHOLESALE, name: "3PW - Nike Store Partners - Whlse Amt" },
    { value: ROUTES.STORE_OWNED, name: "NSO - Nike Store Owned" },
    { value: ROUTES.STORE_HYBRID, name: "NSO - Nike Store Partners Hybrid" },
    { value: ROUTES.VALUE_STORE, name: "NVS - Nike Value Store" },
    { value: ROUTES.NIKE_DOT_COM, name: "NDDC - Nike.com" },
    { value: ROUTES.CONSIGNMENT, name: "NDDC - 3PP Consignment" },
    { value: ROUTES.DROP_SHIP, name: "NDDC - 3PP Drop Ship" },
  ];

  if (!(current === "")){ // ignore landing page
    for (let i=0; i<navBarMenuItemsList.length; i++){
      const channel = navBarMenuItemsList[i].name.split(" - ")[0];
      const businessModel = navBarMenuItemsList[i].name.split(" - ")[1];
      if (country &&
          !(COUNTRIES[country].hasOwnProperty(channel) && COUNTRIES[country][channel].hasOwnProperty(businessModel))
      )
      {
        navBarMenuItemsList[i].disabled = true;
      }
    }
  }

  const getChannelBusinessModelFromRoute = (val: string) => {
    for (let i=0; i<navBarMenuItemsList.length; i++){
      if (navBarMenuItemsList[i].value === val){
        return navBarMenuItemsList[i].name.split(" - ");
      }
    }
    return null;
  }


  useEffect(() => {
    if (current !== loadValue) {
      setLoadValue(`/${current}`);
    }
  }, [current]);


  const changeLocationOnSelect = (val: string) => {
    let countryTerritoryParams = qp.toString();
    let account = "";

    if (!(current === "")){ // ignore landing page
      const channelBusinessModelList = getChannelBusinessModelFromRoute(val);
      const channel = channelBusinessModelList ? channelBusinessModelList[0] : "";
      const businessModel = channelBusinessModelList ? channelBusinessModelList[1] : "";

      if (country && channel === "NDDC" && businessModel.startsWith("3PP")){
        // NOTE: there's currently no country that supports both 3PP Consign and Drop Ship, so the account checkbox will not be preserved when going from one to another
        const defaultKey = Object.keys(COUNTRIES[country][channel][businessModel])[0];
        account = `&${ACCOUNT_PARAM}=${COUNTRIES[country][channel][businessModel][defaultKey]?.toLowerCase()}`;
      }

      if (current.startsWith("nddc-3pp-")){
        qp.delete(ACCOUNT_PARAM);
        countryTerritoryParams = qp.toString();
      }
    }
    else {
      countryTerritoryParams = "";
    }

    history.push(`${val}/${DEFAULT_TAB}?${countryTerritoryParams}${account}`);
    setLoadValue(val);
  };

  const handleLinkClick = () => {
    setLoadValue("");
  };

  const searchString = current.length < 3 ? search : "";
  return (
    <AppBar
      position="fixed"
      sx={{
        ml: `${drawerWidth}px`,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      style={{ backgroundColor: "#1e1e2f", color: "#FFFFFF" }}
    >
      <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
        <Link
          to={`/${searchString}`}
          onClick={handleLinkClick}
          style={{ textDecoration: "none" }}
        >
          <ListItem
            alignItems="center"
            sx={{
              "&:hover, &:focus": { "& svg": { opacity: 1 } },
              height: 80,
            }}
          >
            <ListItemIcon>
              <Avatar
                alt="APLA LOGO"
                src={logo}
                sx={{ width: 40, height: 40, ml: -3 }}
              />
            </ListItemIcon>

            <Typography
              variant="h6"
              noWrap
              component="div"
              style={{ color: "white", marginLeft: -30 }}
            >
              MARKET PLACE OPERATIONS
            </Typography>
            <HomeIcon
              style={{
                color: "white",
                marginLeft: "10px",
                marginTop: "-3px",
              }}
            />
          </ListItem>
        </Link>
        <div style={{ display: "flex" }}>
          <FormControl sx={{ marginLeft: 5, width: 400 }}>
            <Select
              loadValue={loadValue}
              onChange={changeLocationOnSelect}
              menuItems={navBarMenuItemsList}
              id={"shipment-submit"}
              label={"Shipment Submit"}
            />
          </FormControl>
        </div>
        <Box
          marginLeft="auto"
          flexDirection="row"
          display="flex"
          alignItems="center"
        >
          <Nameplate name={name} role={role} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
